import { yupResolver } from '@hookform/resolvers/yup';
import { useBunja } from 'bunja/react';
import { useTranslations } from 'next-intl';
import { useForm } from 'react-hook-form';

import { RhfProvider } from '@flipster/features/src/shared/react-hook-form';
import { Modal } from '@flipster/ui/Modal';

import OpenPosition from '@web/features/modals/TimeTriggerTpslModal/OpenPosition';
import PendingPosition from '@web/features/modals/TimeTriggerTpslModal/PendingPosition';
import { useTimeTriggerTpslModal } from '@web/features/modals/TimeTriggerTpslModal/useTimeTriggerTpslModal';

import { TpslSchema, validationBunja } from './bunja/validation';
import styles from './tpslModal.module.scss';

/**
 * @deprecated Time-trigger orders have been sunset. This modal remains only so users can
 * view/edit/delete leftover time-trigger TP/SL. Do not extend or reuse for new features —
 * use `features/src/tpsl-modal` instead. Removable once no legacy time-trigger orders remain.
 *
 * (구 TPSL Modal은 `features/src/tpsl-modal`로 이전됨. 이 모듈은 TimeTrigger 전용 legacy.)
 */
const TimeTriggerTpslModal = () => {
  const transPosition = useTranslations('Position.r250401');
  const { tpslValidator } = useBunja(validationBunja);
  const methods = useForm<TpslSchema>({
    mode: 'onChange',
    resolver: yupResolver(tpslValidator),
  });

  const { isShow, tpSlInfo, onCloseTimeTriggerTpslModal } = useTimeTriggerTpslModal();

  return (
    <Modal
      size='small'
      isShow={isShow}
      header={transPosition(tpSlInfo?.tpSlType === 'tp' ? 'Take_profit_title' : 'Stop_loss_title')}
      onClose={onCloseTimeTriggerTpslModal}
      className={styles.modal}
      withFooter
    >
      <RhfProvider methods={methods}>
        {tpSlInfo?.positionType === 'open' && <OpenPosition />}
        {tpSlInfo?.positionType === 'pending' && <PendingPosition />}
      </RhfProvider>
    </Modal>
  );
};

export default TimeTriggerTpslModal;
